module.exports = __webpack_public_path__ + "static/img/store-icon1.081c2e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/store-icon1.png
// module id = cdTc
// module chunks = 1